export default "__VITE_ASSET__BJ4n0UDG__"